import { lazy } from 'react'

export const IsolatedFlowInstancesContainerLazy = lazy(() => import('./FlowInstances'))
